import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'components/Loader'
import TextBlock from './TextBlock'
import instructions from './instructions.json'
import Submit from './Submit'

export default class Installation extends React.Component {
  static propTypes = {
    site: PropTypes.object,
    onSubmit: PropTypes.func,
    submitButtonText: PropTypes.string
  }

  render() {
    const {site, onSubmit, submitButtonText} = this.props

    if (!site) return <div className='installation'><Loader /></div>

    const {platform, frontendId} = site

    if (!platform || !instructions[platform]) return null

    const {installation} = instructions[platform]

    return (
      <div className='installation'>
        {this.renderVideoAndDownload(installation)}
        <div className='installation_instructions'>
          {
            installation
              .filter(block => !block.file && !block.video)
              .map((block, index) => <TextBlock key={index} content={block} frontendId={frontendId} />)
          }
        </div>
        <Submit onClick={onSubmit}>{submitButtonText}</Submit>
      </div>
    )
  }

  renderVideoAndDownload(installation) {
    const blocks = installation.filter(block => block.file || block.video)

    if (!blocks.length) return null

    return (
      <div className='installation_video-download'>
        {blocks.map((block, index) => <TextBlock key={index} content={block} />)}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./client/components/Wizard/Installation.js